import React, { Suspense } from 'react';
import ProgressComponent from '../ProgressBar';
import Box from '@mui/material/Box';

/**
 * A minimal loading fallback for lazy-loaded components.
 * Used within dialogs/pages where the parent container already provides structure.
 */
function LoadingFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 100,
        width: '100%',
      }}
    >
      <ProgressComponent visible circleSx={{ color: '#777' }} size={24} />
    </Box>
  );
}

/**
 * Wrapper component for lazy-loaded components.
 * Provides a Suspense boundary with a consistent loading fallback.
 *
 * @param {React.ReactNode} children - The lazy-loaded component to render
 * @param {React.ReactNode} fallback - Optional custom fallback (defaults to LoadingFallback)
 */
export default function LazyComponent({ children, fallback }) {
  return (
    <Suspense fallback={fallback || <LoadingFallback />}>{children}</Suspense>
  );
}
